module.exports = __webpack_public_path__ + "static/media/comma.1859c567.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholders/comma.gif
// module id = 52
// module chunks = 0